<div class="modal fade" id="{{textsStatusModalId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Texts Status</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div *ngIf="textList.length === 0" class="d-flex align-items-center justify-content-center" style="height: 600px;">
                        <p class="text-muted">Texts are being sent in the background. Please check back in a few minutes.</p>
                    </div>
                    <div *ngIf="textList.length > 0">
                        <div class="border border-rounded px-1 mb-0">
                            <table class="table table-sm table-borderless mb-0" style="table-layout: fixed; width: 100%;">
                                <colgroup>
                                    <col style="width: 120px;">
                                    <col style="width: 160px;">
                                    <col style="width: 180px;">
                                    <col style="width: 125px;">
                                    <col style="width: 100px;">
                                    <col style="width: 315px;">
                                    <col style="width: 100px;">
                                    <col style="width: 300px;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Sender</th>
                                        <th>Triggered At (CST)</th>
                                        <th>Recipient</th>
                                        <th>Initiating Process</th>
                                        <th>Direction</th>
                                        <th class="text-content-column">Text Content</th>
                                        <th>Delivery Status</th>
                                        <th>Ack Details</th>
                                    </tr>
                                    <tr class="row-cols-auto">
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchBySender" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByDateTime" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByRecipient" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByInitiatingProcess" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByTextDirection" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByTextContent" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByDeliveryStatus" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                        <th>
                                            <input type="text" class="form-control form-control-sm"
                                                   [(ngModel)]="searchByAckDetails" [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="filterTextList()"
                                                   placeholder="Search" />
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="border border-rounded border-top-0 px-1 table-responsive" style="height: 520px; overflow-y: auto; scrollbar-gutter: stable;">
                            <table class="table table-sm table-borderless table-striped mb-0" style="table-layout: fixed; width: 100%;">
                                <colgroup>
                                    <col style="width: 120px;">
                                    <col style="width: 160px;">
                                    <col style="width: 180px;">
                                    <col style="width: 125px;">
                                    <col style="width: 100px;">
                                    <col style="width: 315px;">
                                    <col style="width: 100px;">
                                    <col style="width: 300px;">
                                </colgroup>
                                <tbody>
                                    <tr *ngFor="let text of filteredTextList; let i = index">
                                        <td>{{text.createdBy}}</td>
                                        <td>{{text.timestampUtc | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
                                        <td>{{text.contactName}} ({{text.toPhoneNumber}})</td>
                                        <td>{{text.initiatingProcess}}</td>
                                        <td>{{text.direction}}</td>
                                        <td>
                                            <div class="message-container d-flex justify-content-between align-items-start">
                                                <button [style.visibility]="needsExpand(text.messageText) ? 'visible' : 'hidden'"
                                                        class="btn btn-link btn-sm p-0 text-decoration-none ms-2 me-2 expand-btn flex-shrink-0"
                                                        (click)="toggleTextRow(i)">
                                                    {{ isTextRowExpanded(i) ? '˄' : '˅' }}
                                                </button>
                                                <pre class="mb-0 text-break flex-grow-1" [class.collapsed]="!isTextRowExpanded(i)">{{text.messageText}}</pre>
                                            </div>
                                        </td>
                                        <td>{{text.deliveryStatus}}</td>
                                        <td>
                                            <div class="message-container d-flex justify-content-between align-items-start">
                                                <button [style.visibility]="needsExpand(text.deliveryStatusDetails) ? 'visible' : 'hidden'"
                                                        class="btn btn-link btn-sm p-0 text-decoration-none ms-2 me-2 expand-btn flex-shrink-0"
                                                        (click)="toggleAckRow(i)">
                                                    {{ isAckRowExpanded(i) ? '˄' : '˅' }}
                                                </button>
                                                <pre class="mb-0 text-break flex-grow-1" [class.collapsed]="!isAckRowExpanded(i)">{{text.deliveryStatusDetails}}</pre>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>